module.exports = __webpack_public_path__ + "static/media/sort-up.8e1bd901.svg";